module.exports = __webpack_public_path__ + "img/Home_Mobile_07.27cc7aeb.jpg";